import { Component, Input } from '@angular/core'
import { MenuItem } from 'primeng/api'

export interface OpMenuItem extends MenuItem {
  hideDivider?: boolean
}

@Component({
  selector: 'op-menu-ng',
  templateUrl: './menu-ng.component.html',
  styleUrls: ['./menu-ng.component.scss'],
})
export class MenuNgComponent {
  @Input() disabled = false
  @Input() ghost = false
  @Input() styleClass?: string
  @Input() expanded = false

  private _items?: OpMenuItem[]

  @Input()
  set items(value: OpMenuItem[] | undefined) {
    this._items = value
    this.processedItems = this.processItems(value)
  }
  get items(): OpMenuItem[] | undefined {
    return this._items
  }
  processedItems: OpMenuItem[] = []
  get menuRootClass(): string {
    return [
      this.styleClass?.trim(),
      this.expanded
        ? 'op-menu-ng--panel-fit-content'
        : 'op-menu-ng--panel-limited',
    ]
      .filter(Boolean)
      .join(' ')
  }

  private processItems(items: OpMenuItem[] | undefined): MenuItem[] {
    if (!items || items.length === 0) {
      return []
    }

    const nonSeparatorItems = items.filter((item) => !item.separator)

    if (nonSeparatorItems.length <= 1) {
      return nonSeparatorItems
    }

    const processed: MenuItem[] = []
    for (let i = 0; i < nonSeparatorItems.length; i++) {
      processed.push(nonSeparatorItems[i])
      if (
        i < nonSeparatorItems.length - 1 &&
        !nonSeparatorItems[i].hideDivider
      ) {
        processed.push({ separator: true })
      }
    }

    return processed
  }
}
